import { CircularProgress, Stack, useTheme } from "@mui/material";

const ActivityLoadingState = () => {
  const theme = useTheme();

  return (
    <Stack alignItems="center" justifyContent="center" minHeight={theme.spacing(25)}>
      <CircularProgress sx={{ color: theme.palette.dsPrimary.v300 }} />
    </Stack>
  );
};

export default ActivityLoadingState;
